import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {Report} from '../../../graphql/reports.datatypes';

interface CloneReportVars {
    id: number;
}

interface CloneReportData {
    cloneReport: Report
}

export const CLONE_REPORT_MUTATION = gql`
    mutation cloneReport($id: Int!) {
        cloneReport(id: $id) {
          id
        }
    }
`;

export const cloneReport = () => useMutation<CloneReportData, CloneReportVars>(
    CLONE_REPORT_MUTATION,
    {
        update: updateCacheByType('Report'),
    }
);

export default cloneReport;